import { CanonicalProvider, Modality } from './providers';

export const PROVIDER_FIELD: Record<Modality, string> = {
  text: 'AiSystem',
  image: 'aiModels',
  audio: 'aiModel',
  voice: 'voiceSystem',
};

type FieldMap = Partial<Record<CanonicalProvider, string>>;

export const LEGACY_FIELD: Record<Modality, FieldMap> = {
  text: {
    openAi: 'aiModel',
    anthropic: 'anthropicModel',
    gemini: 'geminiModel',
    groq: 'groqModel',
    xai: 'xaiModel',
    perplexity: 'perplexityType',
    openSources: 'openSourceModelName',
    palm: 'aiModel',
  },
  image: {
    stabilityAi: 'engineId',
    openAi: 'model',
    gemini: 'model',
    ideogram: 'ideogramModel',
    fal: 'falModel',
    openSources: 'openSourceModel',
    replicate: 'model',
    runwayMl: 'model',
    clipDrop: 'model',
    mistral: 'model',
  },
  audio: {
    openAi: 'aiModel',
    gemini: 'aiModel',
    groq: 'aiModel',
  },
  voice: {
    evenLabs: 'voiceId',
    playHt: 'voice',
    groq: 'groqVoice',
  },
};

export function legacyFieldFor(
  provider: CanonicalProvider,
  modality: Modality,
): string | null {
  return LEGACY_FIELD[modality]?.[provider] ?? null;
}
